<template>
    <div>
        <br>
        <div v-if="!defaultIntent" @click="storeSentence" class="button is-primary is-left">
            <span class="icon"><i class="fas fa-plus"></i></span>
            <span class="is-capitalized">{{ CONSTANTS.getCopy('SENTENCES_BUTTON_NEW_PHRASE') }}</span>
        </div>
        <br><br>
        <table class="table is-striped is-fullwidth">

            <thead>
            <tr>
                <th class="is-capitalized">{{ CONSTANTS.getCopy('SENTENCES_THEAD_LANGUAGE') }}</th>
                <th class="is-capitalized">{{ CONSTANTS.getCopy('SENTENCES_THEAD_INTENT') }}</th>
                <th class="is-capitalized">{{ CONSTANTS.getCopy('SENTENCES_THEAD_PHRASE') }}</th>
                <th class="is-capitalized">{{ CONSTANTS.getCopy('SENTENCES_THEAD_KEYWORDS') }}</th>
                <th class="is-capitalized has-text-centered">{{ CONSTANTS.getCopy('SENTENCES_THEAD_OK') }}</th>
                <th class="is-capitalized has-text-centered">{{ CONSTANTS.getCopy('SENTENCES_THEAD_KO') }}</th>
                <th class="is-capitalized has-text-centered">{{ CONSTANTS.getCopy('SENTENCES_THEAD_ANSWER') }}</th>
                <th class="is-capitalized has-text-centered">{{ CONSTANTS.getCopy('SENTENCES_THEAD_END') }}</th>
                <th class="is-capitalized has-text-centered">{{ CONSTANTS.getCopy('SENTENCES_THEAD_PRIORITY') }}</th>
                <th class="table-button-column"></th>
            </tr>
            </thead>

            <tbody>
            <tr :key="sentence.id" v-for="sentence in sentences">
                <td>{{sentence.language}}</td>
                <td>{{sentence.intent}}</td>
                <td>{{sentence.term}}</td>
                <td>{{sentence.keywords}}</td>
                <td class="has-text-centered">{{sentence.coincidences}}</td>
                <td class="has-text-centered">{{sentence.coincidencesKO}}</td>
                <td class="has-text-centered">
                  <span v-if="sentence.responses" class="icon has-text-success">
                    <i class="fas fa-check"></i>
                  </span>
                </td>
                <td class="has-text-centered">{{sentence.finishBot}}</td>
                <td class="has-text-centered">{{sentence.priority}}</td>
                <td>
                  <div class="field has-addons">
                    <p class="control">
                      <a @click="showAnswers(sentence)"
                         class="button is-primary"
                         title="Ver respuestas">
                        <span class="icon"><i class="fas fa-eye"></i></span>
                      </a>
                    </p>
                    <p class="control">
                      <a :disabled="defaultIntent" @click="updateSentence(sentence)"
                           class="button is-warning"
                           title="Editar">
                        <span class="icon"><i class="fas fa-edit"></i></span>
                      </a>
                    </p>
                    <p class="control">
                      <a :disabled="defaultIntent" @click="copySentence(sentence)"
                           class="button is-info"
                           title="Duplicar">
                        <span class="icon"><i class="fas fa-copy"></i></span>
                      </a>
                    </p>
                    <p class="control">
                      <a :disabled="defaultIntent" @click="deleteSentence(sentence)"
                           class="button is-danger"
                           title="Eliminar">
                        <span class="icon"><i class="fas fa-trash-alt"></i></span>
                      </a>
                    </p>
                  </div>
                </td>
            </tr>
            </tbody>

        </table>

    </div>
</template>

<script>

export default {
  data () {
    return {
      baseUrl: null,
      client: this.$route.params.client,
      intent: this.$route.params.intent,
      defaultIntent: true,
      sentence: this.$route.params.sentence,
      sentences: []
    }
  },
  created () {
    this.getSentences()
    this.getIntentData()
  },
  methods: {
    go (uri) {
      let baseUrl = '/clients/' + this.client + '/intents/' + this.intent + '/sentences/'
      this.$router.push(baseUrl + uri)
    },
    getSentences () {
      this.api.post('/PhraseGetList', {idIntent: this.intent}).then(response => {
        this.sentences = response.phrases
      })
    },
    getIntentData () {
      this.api.post('/IntentById', {idIntent: this.intent}).then(response => {
        this.defaultIntent = (response.intent.name.toLowerCase() === 'default')
      })
    },
    storeSentence () {
      this.go('store')
    },
    showAnswers (sentence) {
      this.go(sentence.idDictionary + '/answers')
    },
    updateSentence (sentence) {
      if (this.defaultIntent) {
        return
      }
      this.go(sentence.idDictionary + '/update')
    },
    copySentence (sentence) {
      if (this.defaultIntent) {
        return
      }
      this.api.post('/PhraseDuplicate', {idDictionary: sentence.idDictionary}).then(() => {
        this.getSentences()
      })
    },
    deleteSentence (sentence) {
      if (this.defaultIntent) {
        return
      }
      let message = '¿Estás seguro de que quieres borrar esta frase?'

      this.dialog.confirm({message}).then(() => {
        this.api.post('/PhraseDelete', {idDictionary: sentence.idDictionary}).then(() => {
          this.getSentences()
        })
      }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Intents/sentencesAndAnswers/sentences/Sentences.vue